import ButtonBase from '@material-ui/core/ButtonBase';
import Chip from '@material-ui/core/Chip';
import { getUserLogGuide, postUserLogGuide } from 'clients/CustomerClient';
import QuantityControlTable from 'components-v2/mocules/QuantityControlTable';
import TourIntro from 'components-v2/mocules/TourIntro';
import LinkComp from 'components/atoms/LinkComp';
import ProductLimitMessage from 'components/mocules/ProductLimitMessage';
import { VARIANT_LIST } from 'components-v2/ui/ConsultSpecialProductBtn';
import { SUBSTITUTE_RECOMMEND_ICON, SUBSTITUDE_REPLACE_ICON } from 'constants/Images';
import { getPathProductBySlug } from 'constants/Paths';
import { SVGPrice } from 'constants/SVG';
import { GUIDE_FEATURE } from 'constants/data/guideline';
import { useEffect, useRef, useState } from 'react';
import { ImageFallbackProductImage, ImageFallbackStatic } from 'utils/ImageFallback';
import { useAuth } from 'context/Auth';
import useOnceInViewport from 'hooks/useOnceInViewport';
import gtag from 'utils/gtag';
import { mapMainSkuStatus } from 'utils/TrackingHelpers';
import styles from './styles.module.css';
import { useRouter } from 'next/router';
import useTrackingMonitorSubstituteProduct from 'hooks/useTrackingMonitorSubstituteProduct';

const ItemProduct = ({ product, slug, imageUrl, name, displayPriceFormated, volume, sku, sellerId, productId, status, productParent }) => {
  const { salePriceFormated = '', discountPercent = 0, consumedMaxQuantity, unit, sellerName, sellerUrl } = product || {};
  const isMaxBuy = consumedMaxQuantity?.maxQuantityConsumed === 0 && consumedMaxQuantity?.maxQuantityType === 'PER_DAY';
  const { trackingMonitorSubstituteClickDetail, trackingMonitorSubstituteAddToCart, trackingMonitorSubstituteMainSKUImpression } =
    useTrackingMonitorSubstituteProduct();
  const router = useRouter();
  const { user } = useAuth();
  const { sellerIdMainSKU, productIdMainSKU, mainSKU, mainType } = router.query || {}

  const handleClickDetailTracking = () => {
    gtag.substituteClickDetail({
      screen: 'Product Detail',
      customerId: user?.customerID,
      sku,
      sellerId,
      productId,
      mainSkuStatus: mapMainSkuStatus(productParent?.errorCode || mainType),
    });
    trackingMonitorSubstituteClickDetail({
      sku,
      sellerId,
      productId,
      type: status === 'NORMAL' ? 'Instock' : status,
      pathname: router.pathname,
      sellerIdMainSKU: productParent?.sellerID || sellerIdMainSKU,
      productIdMainSKU: productParent?.productId || productIdMainSKU,
      mainSKU: productParent?.sku || mainSKU,
      mainType: productParent?.errorCode || mainType,
    });
  };

  // Event "Add substitute product to cart": bấm Add to Cart / nhập số lượng trên card
  const handleAddToCartTracking = () => {
    gtag.substituteClickAddToCart({
      screen: 'Product Detail',
      customerId: user?.customerID,
      sku,
      sellerId,
      productId,
      mainSkuStatus: mapMainSkuStatus(productParent?.errorCode || mainType),
    });
    trackingMonitorSubstituteAddToCart({
      sku,
      sellerId,
      productId,
      type: status === 'NORMAL' ? 'Instock' : status,
      pathname: router.pathname,
      sellerIdMainSKU: productParent?.sellerID || sellerIdMainSKU,
      productIdMainSKU: productParent?.productId || productIdMainSKU,
      mainSKU: productParent?.sku || mainSKU,
      mainType: productParent?.errorCode || mainType,
    });
  };

  // Event "Search result having substitute product impression": card hiện >= 50% viewport (spec MKT)
  const impressionRef = useOnceInViewport(() => {
    gtag.substituteSearchResult({
      screen: 'Product Detail',
      customerId: user?.customerID,
      mainSkuStatus: mapMainSkuStatus(productParent?.errorCode || mainType),
      sku,
      sellerId,
      productId,
    });
    trackingMonitorSubstituteMainSKUImpression({
      sku,
      sellerCode: '',
      productId: productId?.toString() || '',
      type: status === 'NORMAL' ? 'Instock' : status,
      pathname: router.pathname,
      sellerIdMainSKU: (productParent?.sellerID || sellerIdMainSKU)?.toString() || '',
      productIdMainSKU: (productParent?.productId || productIdMainSKU)?.toString() || '',
      mainSKU: productParent?.sku || mainSKU || '',
      mainType: productParent?.errorCode || mainType || 'NORMAL',
    });
  });
  const linkHref = `${getPathProductBySlug(slug)}?isSKUReplace=true&sellerIdMainSKU=${productParent?.sellerID || sellerIdMainSKU}&productIdMainSKU=${productParent?.productId || productIdMainSKU}&mainSKU=${productParent?.sku || mainSKU}&mainType=${productParent?.errorCode || mainType || 'NORMAL'}`;
  return (
    <div className={styles.cardContainer} ref={impressionRef}>
      <div className={styles.itemFlex}>
        <LinkComp
          href={linkHref}
          prefetch={false}
          padding="0px"
          className={null}
          name={null}
          onMouseOver={null}
          target={null}
          onClick={handleClickDetailTracking}
        >
          <ImageFallbackProductImage
            src={imageUrl}
            alt={name}
            width={100}
            height={100}
            title={name && name}
            className={styles.image}
            size="thumbnail"
            objectFit="contain"
          />
        </LinkComp>
        <div className={styles.content}>
          <LinkComp
            href={linkHref}
            prefetch={false}
            padding="0px"
            className={null}
            name={null}
            onMouseOver={null}
            target={null}
            onClick={handleClickDetailTracking}
          >
            <span className={styles.name}>{name ?? ''}</span>
          </LinkComp>
          <span className={styles.volume}>{volume}</span>
          {sellerName && (
            <a className={styles.sellerName} href={sellerUrl} target="_blank" rel="noreferrer">
              {sellerName}
            </a>
          )}
          <div className={styles.priceRow}>
            {displayPriceFormated && <SVGPrice displayPriceFormated={displayPriceFormated} size="lg" textLeft />}
            {discountPercent > 0 && !!salePriceFormated && (
              <>
                <SVGPrice displayPriceFormated={salePriceFormated} fillPath="#333" size="xs" line />
                <Chip className={styles.cardChip} label={`-${discountPercent}%`} size="small" />
              </>
            )}
          </div>
        </div>
      </div>
      <div className={styles.actionCard}>
        <ProductLimitMessage consumedMaxQuantity={consumedMaxQuantity} unit={unit} page="products" className={styles.limitMessage} isNewCard />
        {/* Đã mua hết hạn mức trong ngày -> chỉ còn thông báo, không cho đặt (giống ProductCardNewList) */}
        {!isMaxBuy && (
          <QuantityControlTable
            product={product}
            newCard
            consultVariant={VARIANT_LIST.LIST_HORIZONTAL}
            onAdd={handleAddToCartTracking}
            onChange={handleAddToCartTracking}
          />
        )}
      </div>
    </div>
  );
};

const ReplaceProduct = ({ productReplace = {}, isShowViewMore = false, slugCurrent, showGuide = false, productParent = {} }) => {
  const { slug = '', defaultImage = '', name = '', displayPriceFormated = '', volume = '', sellerInfo, productId, sku, status } = productReplace;
  const router = useRouter();
  const { sellerIdMainSKU, productIdMainSKU, mainSKU, mainType } = router.query || {}
  const { trackingMonitorSubstituteClickMore } = useTrackingMonitorSubstituteProduct();
  if (Object.keys(productReplace).length === 0) {
    return null;
  }
  return (
    <>
      <div className={styles.container} id="product__replace">
        <div className={styles.leftPlace}>
          <span className={styles.title}>
            <ImageFallbackStatic src={SUBSTITUTE_RECOMMEND_ICON} height={24} width={24} />
            Gợi ý
          </span>
          {isShowViewMore && (
            <LinkComp
              href={`/substitutes?slug=${encodeURIComponent(slugCurrent)}`}
              prefetch={false}
              padding="0px"
              className={null}
              name={null}
              onMouseOver={null}
              target={null}
              onClick={() => {
                gtag.substituteClickMore({
                  product: productReplace,
                  screen: 'Product Listing',
                  sku,
                  sellerId: sellerInfo?.sellerID,
                  productId,
                  mainSkuStatus: mapMainSkuStatus(productParent?.errorCode || mainType),
                })
                trackingMonitorSubstituteClickMore({
                  sku: sku,
                  sellerId: sellerInfo?.sellerID,
                  productId: productId,
                  type: status === 'NORMAL' ? "Instock" : status,
                  pathname: router.pathname,
                  sellerIdMainSKU: productParent?.sellerID || sellerIdMainSKU,
                  productIdMainSKU: productParent?.productId || productIdMainSKU,
                  mainSKU: productParent?.sku || mainSKU,
                  mainType: productParent?.errorCode || mainType
                });
              }}
            >
              <ButtonBase className={styles.viewMore}>Xem thêm</ButtonBase>
            </LinkComp>
          )}
        </div>
        <div className={styles.rightPlace}>
          <ItemProduct
            product={productReplace}
            slug={slug}
            imageUrl={defaultImage}
            name={name}
            displayPriceFormated={displayPriceFormated}
            volume={volume}
            sku={sku}
            sellerId={sellerInfo?.sellerID}
            productId={productId}
            status={status}
            productParent={productParent}
          />
          <span className={styles.replaceSticker}>
            <ImageFallbackStatic src={SUBSTITUDE_REPLACE_ICON} height={16} width={16} /> Sản phẩm thay thế
          </span>
        </div>
      </div>

      {showGuide && <TourSubstituteSKU />}
    </>
  );
};

export function TourSubstituteSKU() {
  const [isOpenGuideReplace, setIsOpenGuideReplace] = useState(false);
  const substituteCardRef = useRef();

  useEffect(() => {
    substituteCardRef.current = document.getElementById('product__replace');

    let timeout;
    if (substituteCardRef?.current) {
      // Check if already guided, no need to show the guide
      (async () => {
        const res = await getUserLogGuide({ q: { feature: GUIDE_FEATURE.SUBSTITUTE_SKU_OTHERS } });
        if (res.status !== 'OK') {
          console.error('[ERROR] Get guide substitute cart', res);
          return;
        }

        const guideInfo = res.data?.[0];
        if (guideInfo.isActive && !guideInfo.isGuided) {
          timeout = setTimeout(() => {
            setIsOpenGuideReplace(true);
          }, 1000);
        }
      })();
    }

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  if (!isOpenGuideReplace) {
    return <></>;
  }

  function onFinish() {
    handleFinishGuide();
    turnOnScrollBody();
  }

  async function handleFinishGuide() {
    setIsOpenGuideReplace(false);
    await postUserLogGuide({
      feature: GUIDE_FEATURE.SUBSTITUTE_SKU_OTHERS,
      isViewAll: true,
    });
  }

  function turnOnScrollBody() {
    document.body.style.overflow = 'auto';
    document.body.style.paddingRight = '0px';
  }

  return (
    <TourIntro
      steps={[
        {
          context: (
            <>
              Thuốc sỉ gợi ý bạn sản phẩm thay thế cùng hoạt chất, hàm lượng hoặc cùng công dụng để có thêm sự lựa chọn đặt hàng bạn nhé.
            </>
          ),
          position: 'bottom',
          name: 'infoProduct',
          refCurrent: { current: document.getElementById('product__replace') },
          styles: { width: '480px', fontSize: '16px' },
        },
      ]}
      isHiddenScroll={false}
      isReady
      onFinish={onFinish}
    />
  );
}

export default ReplaceProduct;

